<template lang="pug">
.main
  div.d-flex.mt-4.align-center
    v-img.mt-2.ml-2(:src="require('@/assets/images/logo_main.png')" max-height="40" max-width="100" contain)
    v-spacer
    v-menu(:offset-y='true')
      template(v-slot:activator='{ on }')
        v-btn.button-Aa-medium.mr-1(text v-on="on" small)
          span {{ selectedLang.name }}
          v-card.ml-2(tile)
            v-img(:src="require(`@/assets/images/flags/${selectedLang.flag}.png`)" width="26px" height="14px")
      v-list
        template(v-for="lang in languages")
          v-list-item(dense :key='lang.code' @click="language = lang.code")
            v-list-item-title(v-text="lang.name")
            v-list-item-icon(v-if="lang.code === language")
              v-icon(color="success" v-text="'mdi-check-bold'")
  v-layout.mt-n12(style="height:100vh")
    v-container.my-auto(style="max-width: 600px;" outlined)
      div(v-if="!(email || phone)")
        v-card.mx-3.mt-4( flat outlined )
          h5.text-center.my-8.grey--text.text--darken-3 {{ $t('create_an_account') }}
          v-card.mt-0.pb-5( flat :tile="this.$vuetify.breakpoint.xs")
            .propp-signup(v-if="$route.query.project == 'propp'")
              validate-project-penang(@verified="handleVerification")
            .masjidtanah-signup(v-else-if="$route.query.project == 'masjidtanah'")
              validate-project-masjidtanah(@verified="handleVerification")
            .kgtunku-signup(v-else-if="$route.query.project == 'adun-kgtunku'")
              validate-project-kgtunku(@verified="handleVerification")
            .b40-signup(v-else-if="$route.query.project == 'b40'")
              validate-project-b40(@verified="handleVerification")
            .sme-signup(v-else-if="$route.query.project == 'sme'")
              validate-project-sme(@verified="handleVerification")
            .normal-signup(v-else)
              v-card-text.pt-0(:class="{'pb-0': this.$vuetify.breakpoint.xs}")
                v-btn.mb-4.font-weight-bold.button-AA-medium.white--text.px-0(v-if="!$isMobile" color="info500" x-large block depressed @click="continueGoogleSignUp" height="40" :loading="googleSignUpLoading")
                  v-icon(left small) mdi-google
                  | {{ $t('one_click_signup_gmail') }}
                template(v-if="!registerAffiliate")
                  div.text-center.mb-4(v-if="!$isMobile") {{ $t('or') }}
                  y-phone-input.my-4(v-model="phoneEmail")
                  //- v-text-field.p1(v-model="phoneEmail" :error-messages="phoneFieldError" @keyup.enter="sendVerifyCode" :rules="rules.phoneEmail" outlined hide-details="auto" dense solo flat background-color="basic200" height="40")
                    template(v-slot:label)
                      .p1.basic600--text {{ $t('enter_phone_number') }}
                  v-btn.button-AA-medium.mt-4.mb-4.px-4.elevation-0(color="info500" block dark depressed @click="sendVerifyCode" :loading="loading") {{ $t('sign_up') }}
                  div.mt-4.text-center
                    h6.p2.text-center(style="color: #848484;") {{ $t('you_will_receive') }} {{ registerAffiliate ? '' : 'or SMS' }} {{ $t('to_proceed_signing_up') }}
        div.mt-6.text-center
          h6.c2.text-center(style="color: #848484; font-weight:600;") {{ $t('already_have_account') }}
            span.cursor-pointer.info500--text(text @click="$router.push('/signin')")  {{ $t('log_in') }}.
      div(v-else)
        h5.text-center.mt-16.mb-4.grey--text.text--darken-3 {{ $t('lets_create_your_account') }}
        v-card.mt-4.pb-8(flat :tile="this.$vuetify.breakpoint.xs" :class="{'px-8': !this.$vuetify.breakpoint.xs}")
          v-card-text(:class="{'pb-0': this.$vuetify.breakpoint.xs}")
            v-form(ref="form" v-model="valid")
              p.mb-1.label.basic600--text.text-uppercase(v-if="email && !phone") {{ $t('email_address') }}
              v-text-field.mt-2(v-if="email && !phone" color="primary"  type="email" label="E-mail address" :disabled="true" outlined dense solo flat background-color="basic200"  height="40")
                template(v-slot:label v-model="form.email")
                  .p1.basic500--text(style="color: #c1c1c1;") {{form.email}}
                eva-icon(slot="append" name="checkmark-circle-2-outline" width="20" height="20" :fill="$vuetify.theme.themes[$theme].success400")
              p.mb-1.label.basic600--text.text-uppercase(v-if="phone") {{ $t('phone_number') }}
              y-phone-input.my-4(v-model="form.phone")
              p.mb-1.label.basic600--text.text-uppercase {{ $t('first_name') }}
              v-text-field.mt-2(color="primary" v-model="form.first_name" type="text"  :rules="rules.first_name" dense solo flat background-color="basic200" outlined height="40")
                template(v-slot:label)
                  .p1.basic600--text {{ $t('first_name_placeholder') }}
              p.mb-1.label.basic600--text.text-uppercase {{ $t('last_name') }}
              v-text-field.mt-2(color="primary" v-model="form.last_name" type="text" :rules="rules.last_name" dense solo flat background-color="basic200" outlined   height="40")
                template(v-slot:label)
                  .p1.basic600--text {{ $t('last_name_placeholder') }}
              template(v-if="email && !phone && !googleToken")
                p.mb-1.label.basic600--text.text-uppercase {{ $t('password') }}
                v-text-field.mt-2(color="primary" v-model="form.password" type="password" :rules="rules.password" outlined dense solo flat background-color="basic200"    height="40")
                  template(v-slot:label)
                    .p1.basic600--text {{ $t('password_placeholder') }}
              p.mb-1.label.basic600--text.text-uppercase(v-if="phone") {{ $t('email_address_optional') }}
              v-text-field.mt-2(v-if="phone" color="primary" v-model="form.email" type="email"  :error-messages="emailFieldError" persistent-hint hint="You will receive Yezza training material and order notification" outlined dense solo flat background-color="basic200"   height="40")
                template(v-slot:label)
                  .p1.basic600--text {{ $t('email_address_optional_placeholder') }}
              //- p.mb-1.label.basic600--text.text-uppercase Referral Code (Optional)
              //- v-text-field.mt-2.mb-6(color="primary" v-model="referralCode" :error-messages="referralCode ? referralCodeFieldError : []" persistent-hint  outlined dense solo flat background-color="basic200"   height="40")
              //-   template(v-slot:label)
              //-     .p1.basic600--text Enter your Referral Code
              y-checkbox.mt-4(v-model="agreedTerm" :rules="rules.agreedTerm")
                template(v-slot:label)
                  span.h6.p2.primary400--text
                    | {{ $t('i_agree_to') }} Yezza&nbsp;
                    a.h6.p2.info500--text(href="https://yezza.io/term-of-use/") {{ $t('terms') }}
                    | &nbsp;{{ $t('and') }}&nbsp;
                    a.h6.p2.info500--text(href="https://yezza.io/privacy-policy/") {{ $t('privacy_policy') }}
              y-checkbox.mt-0(v-model="waOptin")
                template(v-slot:label)
                  span.h6.p2.primary400--text {{ $t('i_agree_receive_notification') }}
              v-btn.button-AA-medium.white--text(color="info500" x-large block depressed @click="submit" :loading="loading" height="40" :disabled="!agreedTerm") {{ $t('create_account') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { setOptions, bootstrap } from 'vue-gtag'
import Cookies from 'js-cookie'
import TopBar from '@/components/TopBar'
import ValidateProjectPenang from '@/views/signup/components/ValidateProjectPenang'
import ValidateProjectKgtunku from '@/views/signup/components/ValidateProjectKgtunku'
import ValidateProjectMasjidtanah from '@/views/signup/components/ValidateProjectMasjidtanah'
import ValidateProjectB40 from '@/views/signup/components/ValidateProjectB40'
import ValidateProjectSme from '@/views/signup/components/ValidateProjectSme'
export default {
  name: 'SignUp',
  components: { TopBar, ValidateProjectPenang, ValidateProjectKgtunku, ValidateProjectMasjidtanah, ValidateProjectB40, ValidateProjectSme },
  props: ['email', 'phone', 'code'],
  data: () => ({
    loading: false,
    agreedTerm: false,
    waOptin: false,
    valid: false,
    phoneEmail: '',
    phoneFieldError: '',
    emailFieldError: '',
    referralCodeFieldError: '',
    referralCode: '',
    registerAffiliate: false,
    googleToken: null,
    googleSignUpLoading: false,
    form: {
      first_name: null,
      last_name: null,
      email: null,
      password: null,
      phone: null,
      otp: null
    },
    passwordFieldError: '',
    projectId: null,
    language: null,
    languages: [
      { name: 'English', code: 'en', flag: 'gb' },
      { name: 'Bahasa Indonesia', code: 'id', flag: 'id' },
    ],
    rules: {
      first_name: [
        v => !!v || 'First name is required'
      ],
      last_name: [
        v => !!v || 'Last name is required'
      ],
      phoneEmail: [
        v => !!v || 'Phone number or e-mail address is required'
      ],
      email: [
        v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
      ],
      postcode: [
        v => !!v || 'Postcode is required'
      ],
      password: [
        v => !!v || 'Password is required',
        v => v.length >= 8 || 'Password must be 8 or more characters',
      ],
      agreedTerm: [
        v => !!v || 'You must agree with with Yezza Terms'
      ]
    }
  }),
  computed: {
    ...mapGetters({
      lang: 'language/getLanguage'
    }),
    authMethod () {
      return this.phoneEmail.includes('@') ? 'email': 'phone'
    },
    selectedLang () {
      let lang = this.languages.find(f => f.code === this.language)
      return lang || { name: 'English', code: 'en', flag: 'gb' }
    }
  },
  watch: {
    'form.email'() {
      this.emailFieldError = ''
    },
    language (val) {
      if (!val || val === 'undefined' || val === 'null') {
        this.$store.commit('language/setLanguage', 'en')
        this.language = 'en'
      } else {
        this.$store.commit('language/setLanguage', val)
      }
    }
  },
  mounted () {
    if (this.$subdomain && this.$subdomain !== 'app') {
      window.location.href = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signup`
    }

    // SignUp Type
    const signupType = this.$route.query.signuptype
    if (signupType) {
      localStorage.setItem('signup-type', signupType)
    }

    //Project
    const projectId = this.$route.query.project
    if (projectId) {
      this.projectId = projectId

    } else {
      this.projectId = Cookies.get('project_id')
    }

    // Affiliate
    const afId = this.$route.query.af_id
    if (afId) {
      const currentAfId = Cookies.get('af_id')
      if (currentAfId != afId) {
        Cookies.set('af_id', afId, { expires: 30 })
      }
      let query = {...this.$route.query}
      delete query.af_id
      this.$router.replace({ query })
    }
    const afIdCookie = Cookies.get('af_id')
    this.$store.commit('ui/setAffiliateId', afIdCookie)

    // Register Affiliate
    const register_affiliate = this.$route.query.register_affiliate || Cookies.get('register_affiliate') || null
    if (register_affiliate === 'true') {
      this.registerAffiliate = true
    }

    this.handleGoogleSignUpCallback()

    this.prefillForm()

    this.language = this.lang
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    prefillForm () {
      if (this.phone) {
        this.$set(this.form, 'phone', this.phone)
      }
      if (this.email) {
        this.$set(this.form, 'email', this.email)
      }
    },
    handleVerification(phoneEmail) {
      this.phoneEmail = phoneEmail
      this.sendVerifyCode()
    },
    sendVerifyCode () {
      if (!this.phoneEmail) {
        return
      }
      this.phoneFieldError = ''
      this.loading = true
      if (this.$route.query.project) {
        Cookies.set('project_id', this.$route.query.project, { expires: 1 })
      }

      if (this.$route.query.register_affiliate) {
        Cookies.set('register_affiliate', this.$route.query.register_affiliate, { expires: 30 })
      }

      if (this.authMethod === 'email' || this.registerAffiliate) {
        this.phoneFieldError = 'Phone number must be valid'
        this.loading = false
        return
        // this.form.email = this.phoneEmail
        // let emailValid = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.phoneEmail)
        // if (!emailValid) {
        //   this.phoneFieldError = 'E-mail must be valid'
        //   this.loading = false
        //   return
        // }
        // this.$axios.get(`/users/check_email/?email=${encodeURIComponent(this.form.email)}`)
        //   .then(resp => {
        //     if (resp.data.available) {
        //       this.$axios.post('/users/send_verification_code/', { email: this.form.email })
        //         .then(() => {
        //           this.$router.push({ name: 'Verify', params: { email: this.form.email, pushTo: 'SignUp' }})
        //         })
        //         .catch(() => {})
        //         .finally(() => {
        //           this.loading = false
        //           })
        //     } else {
        //       this.loading = false
        //       let message = `${this.form.email} has already registered with Yezza. Proceed to sign in.`
        //       if (this.registerAffiliate) {
        //         message = `You already have an account with Yezza. Please sign in to register as affiliate`
        //       }
        //       this.showMessage(['error', message])
        //       this.$router.push({name: 'SignIn', params: { fillEmail: this.form.email }})
        //     }
        //   }).catch(() => {})
      } else if (this.authMethod === 'phone') {
        this.form.phone = this.phoneEmail
        this.$axios.get(`/users/check_phone/?phone=${encodeURIComponent(this.form.phone)}`)
          .then(resp => {
            if (resp.data.available) {
              this.$axios.post('/users/request_otp/', { phone: this.form.phone })
                .then(() => {
                  this.$router.push({ name: 'Verify', params: { phone: this.form.phone, pushTo: 'SignUp' }})
                })
                .catch((err) => {
                  let msg = this.$t('error_message.unable_to_complete_request')
                  if (err.response.data[0]) {
                    msg = err.response.data[0]
                  }
                  this.showMessage(['error', msg])
                })
                .finally(() => {
                  this.loading = false
                })
            } else {
              this.loading = false
              let message = `${this.form.email} has already registered with Yezza. Proceed to sign in.`
              if (this.registerAffiliate) {
                message = `You already have an account with Yezza before, please proceed logging in to register as affiliate`
              }
              this.showMessage(['error', message])
              this.$router.push({name: 'SignIn', params: { fillEmail: this.form.phone }})
            }
          }).catch(() => {})
      }
    },
    async submit () {
      this.referralCodeFieldError = ''
      this.valid = true
      this.$refs.form.validate()
      if (!this.valid) {
        return
      }

      this.loading = true

      if (this.referralCode && this.referralCode.trim()) {
        try {
          await this.$axios.get(`/companies/check_referral_code/?code=${this.referralCode.trim()}`)
        } catch {
          this.referralCodeFieldError = 'Referral code must be valid'
          this.loading = false
          return
        }
      }
      let form = {
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        fbq: {
          cookies: Cookies.get(),
          user_agent: navigator.userAgent
        }
      }
      if (this.email) {
        form.email = this.form.email
        if (!this.googleSignUp) {
          form.google_token = this.googleToken
        } else {
          form.password = this.form.password
          form.code = this.code
        }
      } else if (this.phone) {
        if (this.form.email) {
          let emailValid = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.form.email)
          if (!emailValid) {
            this.emailFieldError = 'E-mail must be valid'
            this.loading = false
            return
          }

          let emailCheckResp = await this.$axios.get(`/users/check_email/?email=${encodeURIComponent(this.form.email)}`)
          if (emailCheckResp.data.available) {
            form.email = this.form.email
          } else {
            this.emailFieldError = 'E-mail not available. Choose different email.'
            this.loading = false
            return
          }

          form.email = this.form.email
        }
        form.phone = this.form.phone
        form.otp_verified_token = this.code
      }
      if (this.projectId) {
        form['sponsor'] = this.projectId

      }
      try {
        let userCreateResp = await this.$axios.post('/users/', form)
        this.$store.commit('user/setUser', userCreateResp.data)
        if (this.waOptin) {
          this.$axios.patch(`/users/${userCreateResp.data.id}/`, { whatsapp_optin: true })
            .then(resp => {
              this.$store.commit('user/setUser', resp.data)
            })
            .catch(() => {})
        }
        if (this.referralCode) {
          this.$store.commit('user/setReferralCode', this.referralCode.trim())
        }
        if (this.registerAffiliate) {
          await this.$axios.post(`/partners/`)
            .then(() => {
              Cookies.remove('register_affiliate')
            })
            .catch(() => {})
        }
        this.trackPixel(userCreateResp.data.id)
        this.trackGtag()
        this.$router.push('/admin')
      } catch (e) {
        if (e.response) {
          if (e.response.data.email) {
            this.showMessage(['error', e.response.data.email[0]])
          }
          if (e.response.data.password) {
            this.showMessage(['error', e.response.data.password[0]])
          }
        }
      } finally {
        this.loading = false
      }
    },
    async continueGoogleSignUp () {
      if (this.$route.query.register_affiliate) {
        Cookies.set('register_affiliate', this.$route.query.register_affiliate, { expires: 30 })
      }
      const redirectUri = window.location.origin + '/signup'
      const nonce = (Math.random() + 1).toString(36).substring(2)
      window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${process.env.VUE_APP_GOOGLE_CLIENT_ID}&redirect_uri=${redirectUri}&state=google&response_type=id_token&nonce=${nonce}&scope=profile email`
    },
    async handleGoogleSignUpCallback () {
      if (!this.$route.hash) return
      let qs = new URLSearchParams(this.$route.hash.substring(1))
      let googleToken = qs.get('id_token')
      if (qs.get('state') === 'google' && googleToken) {
        this.googleSignUpLoading = true

        try {
          let resp = await this.$axios.get(`https://oauth2.googleapis.com/tokeninfo?id_token=${googleToken}`)
          if (resp.data.email && resp.data.email_verified) {
            let emailCheckResp = await this.$axios.get(`/users/check_email/?email=${encodeURIComponent(resp.data.email)}`)
            if (!emailCheckResp.data.available) {
              this.googleSignUpLoading = false
              let message = `${resp.data.email} has already registered with Yezza. Proceed to sign in.`
              if (this.registerAffiliate) {
                message = `You already have an account with Yezza. Please sign in to register as affiliate`
              }
              this.showMessage(['error', message])
              this.$router.push({name: 'SignIn'})
              return
            }

            this.form.email = resp.data.email
            this.form.first_name = resp.data.given_name
            this.form.last_name = resp.data.family_name
            this.googleToken = googleToken
            this.email = resp.data.email
          }
        } catch (err) {
          this.showMessage(['error', err.response.data])
        } finally {
          this.googleSignUpLoading = false
        }
      }
    },
    trackGtag () {
      setOptions({
        config: { id: process.env.VUE_APP_YEZZA_GTAG_ID }
      })
      bootstrap().then(() => {
        this.$gtag.linker({
          'domains': ['yezza.com', 'yezza.io']
        })
        this.$gtag.event('generate_lead')
      })
    },
    trackPixel (eventID) {
      window.fbq('trackSingle', process.env.VUE_APP_YEZZA_FB_PIXEL_ID, 'Lead', null, {eventID: eventID})
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "create_an_account": "Create an account",
    "one_click_signup_gmail": "ONE-CLICK SIGNUP WITH GMAIL",
    "enter_phone_number": "Enter Phone Number",
    "sign_up": "SIGN UP",
    "you_will_receive": "You will receive an email",
    "to_proceed_signing_up": "to proceed with signing up.",
    "already_have_account": "Already have an account?",
    "lets_create_your_account": "Let's create your account",
    "first_name": "First Name",
    "first_name_placeholder": "Enter your first name",
    "last_name": "Last Name",
    "last_name_placeholder": "Enter your last name",
    "password": "Password",
    "password_placeholder": "Create a password",
    "email_address_optional": "Email Address (Optional)",
    "email_address_optional_placeholder": "Enter your email address",
    "i_agree_to": "I agree to",
    "terms": "Terms",
    "and": "and",
    "privacy_policy": "Privacy Policy",
    "i_agree_receive_notification": "I agree to receive notification and promotion messages via WhatsApp"
  },
  "id": {
    "create_an_account": "Buat akun",
    "one_click_signup_gmail": "DAFTAR SATU-KLIK DENGAN GMAIL",
    "enter_phone_number": "Masukkan Nomor Telepon",
    "sign_up": "DAFTAR",
    "you_will_receive": "Anda akan menerima email",
    "to_proceed_signing_up": "untuk melanjutkan pendaftaran.",
    "already_have_account": "Sudah punya akun?",
    "lets_create_your_account": "Ayo buat akun kamu",
    "first_name": "Nama Depan",
    "first_name_placeholder": "Masukkan nama depan kamu",
    "last_name": "Nama Belakang",
    "last_name_placeholder": "Masukkan nama belakang kamu",
    "kata sandi": "Kata sandi",
    "password_placeholder": "Buat kata sandi",
    "email_address_optional": "Alamat Email (Opsional)",
    "email_address_optional_placeholder": "Masukkan alamat email kamu",
    "i_agree_to": "Saya setuju",
    "terms": "Persyaratan",
    "and": "dan",
    "privacy_policy": "Kebijakan Privasi",
    "i_agree_receive_notification": "Saya setuju untuk menerima pesan pemberitahuan dan promosi melalui WhatsApp"
  }
}
</i18n>